import { Routes, Route, useLocation } from "react-router-dom";
import ManageLocations from "../Components/Locations/ManageLocations";
import Dashboard from "../Pages/dashboard";
import Login from "../Pages/login";
import HistoricalWeatherData from "../Pages/historicalData";
import SideBar from "../Layout/SideBar";
import Navbar from "../Layout/Navbar";
import RealTimeData from "../Pages/realtimeData";
import DailyForcastTable from "../Components/Dashboard/DailyForcastTable";
import HourlyForcastTable from "../Components/Dashboard/HourlyForcastTable";
import Privateroute from "./Privateroute";
import NotFound from "../Pages/notFound";
import { useSelector } from "react-redux";
import Contact from "../Layout/Contact";

export default function AllRoutes() {
  let location = useLocation();
  const { hamburger } = useSelector((store) => store.dashboard)


  const allWebsiteRoutes = [
    "/dashboard",
    "/manage-location",
    "/near-realtime-data",
    "/historical-data",
    "/daily-forcast-table",
    "/hourly-forcast-table",
    "/contact",
  ];
  const isLayout = allWebsiteRoutes.includes(location.pathname.toLowerCase());
  return (
    <div className="lg:h-screen lg:w-screen lg:flex ">
      {isLayout && (
        <div className={` lg:w-[5vw] ${hamburger ? "lg:hidden sm:fixed sm:w-[20vw] z-20" : "lg:block sm:hidden z-0"}  `}>
          <SideBar />
        </div>
      )}
      <div className="lg:flex-grow lg:flex lg:flex-col lg:w-[90vw]  " >
        {isLayout && <Navbar />}
        <div
          className={`lg:flex-grow ${location.pathname === "/" || !isLayout
              ? ""
              : "lg:p-2 bg-secondaryBgColor dark:bg-darkModeSecondaryBgColor"
            } `}
        >
          <Routes>
            <Route path="/" element={<Login />} />
            <Route path="/dashboard" element={<Dashboard />} />
            {/* <Route path="/loginPage" element={<Login />} /> */}
            <Route
              path="/historical-data"
              element={
                <Privateroute>
                  <HistoricalWeatherData />
                </Privateroute>
              }
            />
            <Route path="/manage-location" element={<ManageLocations />} />
            <Route
              path="/near-realtime-data"
              element={
                <Privateroute>
                  <RealTimeData />
                </Privateroute>
              }
            />
            <Route
              path="/daily-forcast-table"
              element={<DailyForcastTable />}
            />
            <Route
              path="/contact"
              element={<Contact />}
            />
            <Route
              path="/hourly-forcast-table"
              element={<HourlyForcastTable />}
            />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </div>
      </div>
    </div>
  );
}
